import { render, staticRenderFns } from "./SolicitacoesTreinamento.vue?vue&type=template&id=f9df7f76"
import script from "./SolicitacoesTreinamento.vue?vue&type=script&lang=js"
export * from "./SolicitacoesTreinamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports